// 全局视口变化刷新控制器
class ViewportRefreshController {
  constructor(options = {}) {
    // 默认配置
    this.config = {
      // 防抖延迟时间(ms)
      debounceDelay: 1000,
      // 仅检测宽度变化
      checkWidthOnly: true,
      // 宽度变化阈值(px)，超过此值才触发刷新
      widthChangeThreshold: 50,
      // 高度变化阈值(px)，超过此值才触发刷新
      heightChangeThreshold: 100,
      // 调试模式
      debug: false,
      // 提示信息
      message: '检测到屏幕尺寸变化，页面正在更新布局，请稍候...',
      // 提示显示时间(ms)，如果小于等于0则等待刷新
      notificationDuration: 800,
      ...options
    };
    
    // 记录初始视口尺寸
    this.lastViewport = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    
    // 绑定事件处理函数
    this.handleResize = this.debounce(this.checkViewportChange.bind(this), this.config.debounceDelay);
    
    // 创建提示元素
    this.createNotificationElement();
    
    // 启动监听
    this.start();
  }
  
  // 创建提示信息元素
  createNotificationElement() {
    // 如果已存在则移除
    if (document.getElementById('viewport-refresh-notification')) {
      document.body.removeChild(document.getElementById('viewport-refresh-notification'));
    }
    
    // 创建遮罩层
    this.notification = document.createElement('div');
    this.notification.id = 'viewport-refresh-notification';
    this.notification.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s ease;
    `;
    
    // 添加加载图标
    const spinner = document.createElement('div');
    spinner.style.cssText = `
      width: 40px;
      height: 40px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 16px;
    `;
    
    // 添加动画样式
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
    
    // 添加文本
    const text = document.createElement('div');
    text.textContent = this.config.message;
    text.style.cssText = `
      font-size: 16px;
      color: #ffffff;
      font-family: sans-serif;
    `;
    
    // 组合元素
    this.notification.appendChild(spinner);
    this.notification.appendChild(text);
    document.body.appendChild(this.notification);
  }
  
  // 显示提示信息
  showNotification() {
    if (this.notification) {
      this.notification.style.opacity = '1';
      this.notification.style.pointerEvents = 'auto';
    }
  }
  
  // 隐藏提示信息
  hideNotification() {
    if (this.notification) {
      this.notification.style.opacity = '0';
      this.notification.style.pointerEvents = 'none';
    }
  }
  
  // 防抖函数
  debounce(func, delay) {
    let timer = null;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
  
  // 检查视口变化
  checkViewportChange() {
    const current = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    
    const widthChange = Math.abs(current.width - this.lastViewport.width);
    const heightChange = Math.abs(current.height - this.lastViewport.height);
    
    // 调试信息
    if (this.config.debug) {
      // console.log(`视口变化 - 宽度: ${widthChange}px, 高度: ${heightChange}px`);
    }
    // 判断是否需要刷新
    let shouldRefresh = false;
    if (this.config.checkWidthOnly) {
      // 仅检查宽度变化
      shouldRefresh = widthChange >= this.config.widthChangeThreshold;
    } else {
      // 同时检查宽度和高度变化
      shouldRefresh = widthChange >= this.config.widthChangeThreshold || 
                     heightChange >= this.config.heightChangeThreshold;
    }
    if (shouldRefresh) {
      if (this.config.debug) {
        // console.log('视口变化达到阈值，将刷新页面');
      }
      // 显示提示信息
      this.showNotification();
      
      // 更新记录的视口尺寸
      this.lastViewport = current;
      
      // 延迟刷新，让用户看到提示
      const refreshDelay = this.config.notificationDuration > 0 ? this.config.notificationDuration : 500;
      setTimeout(() => {
        window.location.reload();
      }, refreshDelay);
    }
  }
  
  // 启动监听
  start() {
    window.addEventListener('resize', this.handleResize);
    if (this.config.debug) {
      // console.log('视口变化监听已启动');
    }
  }
  
  // 停止监听
  stop() {
    window.removeEventListener('resize', this.handleResize);
    if (this.config.debug) {
      // console.log('视口变化监听已停止');
    }
  }
  
  // 更新提示信息
  updateMessage(newMessage) {
    this.config.message = newMessage;
    const textElement = this.notification.querySelector('div:last-child');
    if (textElement) {
      textElement.textContent = newMessage;
    }
  }
}

// 导出单例实例，确保全局唯一
export const viewportRefresh = new ViewportRefreshController({
  // 可以在这里修改默认配置
  // debug: true,
  // widthChangeThreshold: 100,
  // message: '页面正在适应新尺寸...',
  // notificationDuration: 1000
});
